
import React from 'react'
import { FeaturingItem } from './featuringItem';


export const Featuring = ({ title }) =>{

    const [features] = React.useState([
    {
        position:'C++ Developer',
        company: 'Microsoft',
        start: '03/09/2020',
        working: true,
        end:false,
        city:'Egypt',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure dolorem ex doloremque laboriosam quidem rem incidunt esse atque voluptatum aut, beatae labore ipsum nulla deserunt itaque molestias nisi quasi veniam.',
    },
    {
        position:'Kernel Engineer',
        company: 'Apriorit',
        start: '03/07/2020',
        working: true,
        end:'01/03/2022',
        city:'Ukraine',
        description:'Iure dolorem ex doloremque laboriosam quidem rem incidunt deserunt itaque molestias  esse atque voluptatum aut, beatae labore ipsum veniam.',
    }
    ])

    return (
        <div className="featuring">
            {features?.length>0 && title && <h3 className="">{title}</h3> }
            <div className="row">
                <div className="col-12">
                    <div className="featuring_list">

                        <ul>
                           {features?.length>0 && features.map((item,i)=>(
                               <FeaturingItem key={'featuring'+i} item={item} />
                           ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}